module.exports = __webpack_public_path__ + "img/flag_nl.a63cab13.svg";